import Button from "@components/Button/Button";
import { KeywordVersion3Props } from "@components/Button/utlis/types";
import IconImg from "@components/Icon/IconImg";
import { IconTypeEnum } from "@components/Icon/types";

export default function KeywordVersion3({
  handleClick,
  keyword,
  className,
  isTagFollowed,
  isAnonymousUser,
}: KeywordVersion3Props): React.ReactElement {
  const tagName = `'${keyword?.name}'` || "";

  const labelText = isTagFollowed && !isAnonymousUser ? "Unfollow" : "Follow";
  const iconImg =
    isTagFollowed && !isAnonymousUser
      ? IconTypeEnum.unfollow
      : IconTypeEnum.follow;

  return (
    <Button
      className={className}
      onClick={handleClick}
      testId="keyword-button-component"
    >
      <p className="mb-0 text-wrap text-left">
        {labelText} {tagName}
      </p>

      <IconImg icon={iconImg} iconSize={24} imgAlt="follow icon" />
    </Button>
  );
}
